export const USERLIST = 'USERLIST'
export const HOTEL_LIST = 'HOTEL_LIST'
export const ITEMLIST = 'ITEMLIST'
